import {useState} from 'react';
import {motion, useAnimationControls} from 'framer-motion';
import {SwiperSlide} from 'swiper/react';

export default function SubSection({ data: { index, color, subTitle, title, description } }) {

  const [isShowDetail, setIsShowDetail] = useState(false);

  const plusBtnControls = useAnimationControls();

  const clickPlus = () => {
    plusBtnControls.start({
      scale: [1, 1.1, 1],
      transition: {
        duration: 0.2,
        ease: 'easeInOut'
      }
    });
    setIsShowDetail(prev => !prev);
  }

  return (
    <section
      data-bg-type='colorful'
      className='relative w-full h-full bg-no-repeat bg-center bg-cover px-[25px] py-[120px] lg:p-[160px]'
      style={{backgroundImage: `url(${process.env.REACT_APP_STATIC_URL}/images/Main/Section${index}_Background.jpg)`}}
    >
      <div
        className={`absolute w-full h-screen inset-0 bg-white transition-opacity duration-500 ease-in-out ${isShowDetail ? 'opacity-80' : 'opacity-0'}`}/>

      <div
        className={'relative z-10 transition-all transform  duration-[800ms] ease-in-out ' + (isShowDetail && '-translate-y-8')}>
        <h3 className={'text-primary-200 text-body1 lg:text-title3' + (isShowDetail && ' hidden')}>
          {subTitle}
        </h3>

        <h2
          className={`text-title3 lg:text-display2 mt-[20px] lg:mt-[28px] ${isShowDetail ? 'text-black' : ('text-' + color)}`}>
          {title.split('\n').map((item, idx) => <p key={idx}>{item}</p>)}
        </h2>

        <div>
          <div
            onClick={clickPlus}
            className='flex justify-center items-center w-[48px] h-[48px] lg:w-[48px] lg:h-[48px] mt-[32px] lg:mt-[40px] bg-[rgb(0,0,0,0.5)] rounded-[100px] cursor-pointer'>
            <motion.svg
              animate={plusBtnControls}
              width="40%" height="40%"
              viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {
                isShowDetail ?
                  <path d="M18 6L6 18M6 6L18 18" stroke="#FFF" strokeWidth="2" strokeLinecap="round"
                        strokeLinejoin="round"/>
                  :
                  <path d="M5 12H19M12 5V19" stroke="#FFF" strokeWidth="2" strokeLinecap="round"
                        strokeLinejoin="round"/>
              }
            </motion.svg>
          </div>
        </div>

        <div className={'mt-[40px] text-heading3 lg:text-heading2 text-label-100 ' + (!isShowDetail && 'hidden')}>
          {description.split('\n').map((item, idx) => <p key={idx}>{item}</p>)}
        </div>
      </div>
    </section>
  )
}